import {
  Input,
  SimpleGrid,
  Box,
  Text,
  InputGroup,
  InputRightElement,
  IconButton,
  Button,
} from '@wegroup/design-system';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import QuestionBox from './QuestionBox';
import { IconActionClose } from 'wg-fe-ui';
import { parse } from 'query-string';
import { useFlowsSelector } from '../../../../../common/src/utils/globalVariables';
import { FlowsQuestionGroup } from '../../../types/FlowsTypes';
import { useFlowsRouteParams } from '../../../hooks/useFlowsRouteParams';

const QuestionHopper: React.FC<React.PropsWithChildren<unknown>> = () => {
  const history = useHistory();
  const location = useLocation();
  const { flowId, sessionId } = useFlowsRouteParams();
  const { lastRoute } = parse(location.search);
  const questionnaire = useFlowsSelector((state) => state.flows.questionnaire);

  const [filterText, setFilterText] = useState<string>();

  const questionnaireFilter = (group: FlowsQuestionGroup) => {
    if (!filterText) return true;
    if (group.id.includes(filterText)) {
      return true;
    } else if (group.questions.some(({ id }) => id.includes(filterText))) {
      return true;
    } else if (group.tag.includes(filterText)) {
      return true;
    }
    return false;
  };

  return (
    <Box w="100%">
      <Button
        onClick={() =>
          history.push(
            `/flows/${flowId}/devtools/${sessionId}/overview?lastRoute=${lastRoute}`,
          )
        }
      >
        Back to overview
      </Button>
      <Text mb="2">Filter questions:</Text>
      <InputGroup>
        <Input
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Search..."
        />
        <InputRightElement width="4.5rem">
          <IconButton
            variant="tertiary"
            onClick={() => setFilterText('')}
            aria-label="Clear search input"
            icon={<IconActionClose />}
          />
        </InputRightElement>
      </InputGroup>
      <SimpleGrid w="100%" columns={2}>
        {questionnaire.groups
          .filter(questionnaireFilter)
          .map(({ id, tag, questions }, index) => {
            return (
              <QuestionBox
                key={`group_${id}`}
                tag={tag}
                groupId={id}
                questions={questions}
                onClick={() =>
                  history.push(
                    `/flows/${flowId}/questions/${sessionId}/${index}`,
                  )
                }
              />
            );
          })}
      </SimpleGrid>
    </Box>
  );
};

export default QuestionHopper;
